// src/helper/objHelper.ts
class ObjHelper {
    static deepEqual(obj1: any, obj2: any): boolean {
        if (obj1 === obj2) {
            // Handles primitive values, strict equality, and reference equality.
            return true;
        }

        if (obj1 !== obj1 && obj2 !== obj2) {
            // Handle NaN case (NaN !== NaN is true in JS)
            return true;
        }

        if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
            // If either is not an object (or null), they are not equal
            return false;
        }

        if (Object.prototype.toString.call(obj1) !== Object.prototype.toString.call(obj2)) {
            // Check if both objects are of the same type
            return false;
        }

        if (obj1 instanceof Date && obj2 instanceof Date) {
            // Handle Date objects
            return obj1.getTime() === obj2.getTime();
        }

        if (obj1 instanceof RegExp && obj2 instanceof RegExp) {
            // Handle RegExp objects
            return obj1.toString() === obj2.toString();
        }

        if (obj1 instanceof Map && obj2 instanceof Map) {
            // Handle Map objects
            if (obj1.size !== obj2.size) return false;
            for (const [key, value] of obj1) {
                if (!obj2.has(key) || !ObjHelper.deepEqual(value, obj2.get(key))) {
                    return false;
                }
            }
            return true;
        }

        if (obj1 instanceof Set && obj2 instanceof Set) {
            // Handle Set objects
            if (obj1.size !== obj2.size) return false;
            for (const value of obj1) {
                if (![...obj2].some((v) => ObjHelper.deepEqual(v, value))) {
                    return false;
                }
            }
            return true;
        }

        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            // Handle arrays
            if (obj1.length !== obj2.length) return false;
            for (let i = 0; i < obj1.length; i++) {
                if (!ObjHelper.deepEqual(obj1[i], obj2[i])) {
                    return false;
                }
            }
            return true;
        }

        // Compare object keys and values
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return false;

        for (const key of keys1) {
            if (!keys2.includes(key) || !ObjHelper.deepEqual(obj1[key], obj2[key])) {
                return false;
            }
        }

        return true;
    }
}

export default ObjHelper;